var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ChartCard',{staticClass:"clicks-card",attrs:{"title":"Projected stats","is-loading":_vm.isLoading,"highlights":_vm.currentTotals}},[_c('ChartWrapper',{attrs:{"width":"100%","height":"300","type":"line","options":_vm.chartOptions,"data":_vm.series}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }